import { Box } from '@mui/material'

const TestsHierarchicalListRow = ({ level = 0, children, onClick = null, isActiveFolder }) => (
  <Box
    className="testCasesHierarchicalListRow"
    onClick={onClick}
    sx={{
      pl: `${level * 6}px`,
      cursor: onClick ? 'pointer' : 'default',
      backgroundColor: isActiveFolder ? 'rgba(69, 116, 210, 0.1)' : 'inherit'
    }}
  >
    {children}
  </Box>
)

export default TestsHierarchicalListRow